const Reflux = require("reflux");
const biAPI = require("app/util/api/bi-api");
const dateToParam = require("./util/date-to-param").dateToParam;

const DealLossReasonsActions = Reflux.createActions({
  "fetchData": { children: ["completed", "failed"] }
});

DealLossReasonsActions.fetchData.listen(function(period, users, funnel) {
  let params = {
    start_date: dateToParam(period.startDate),
    end_date: dateToParam(period.endDate),
    users: users,
    funnel: funnel
  };

  biAPI.fetch("/deal_loss_reasons", params, this.completed, this.failed);
});

module.exports = DealLossReasonsActions;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/actions/deal-loss-reasons-actions.js